import React, { useMemo } from 'react';
import Header from '../components/Header';
import HeroSlider from '../components/HeroSlider';
import FeaturedService from '../components/FeaturedService';
import AboutSection from '../components/AboutSection';
import ServicesGrid from '../components/ServicesGrid';
import WhyChoose from '../components/WhyChoose';
import ShopSection from '../components/ShopSection';
import TaglineSection from '../components/TaglineSection';
import TrustSection from '../components/TrustSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import AppearancePreFooter from '../components/AppearancePreFooter';
import CrossDivisionStrip from '../components/CrossDivisionStrip';
import RecommendedForYou from '../components/RecommendedForYou';
import WinningBundlesRail from '../components/WinningBundlesRail';
import ContinueShoppingChip from '../components/ContinueShoppingChip';
import SeoHead from '../components/SeoHead';
import StructuredData from '../components/StructuredData';
import { useI18n } from '../context/I18nContext';
import { getOrganizationSchema } from '../data/orgSchema';

export default function Home() {
  const { t, lang } = useI18n();

  const schemas = useMemo(() => {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    // Canonical Organization schema — single source of truth shared with
    // /copyright. Keeps name, address, contact, sameAs identical sitewide.
    const orgSchema = getOrganizationSchema(origin);

    return [
      orgSchema,
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        '@id': `${origin}/#website`,
        url: origin || 'https://www.zhelta.com',
        name: 'ZHELTA',
        inLanguage: lang,
        publisher: { '@id': `${origin}/#organization` },
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${origin}/?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
    ];
  }, [lang]);

  return (
    <div className="min-h-screen bg-[#F5F5F7]">
      <SeoHead
        pageKey="home"
        path="/"
        title="ZHELTA — Technology, Learning, and Digital Services for what's next"
        description="ZHELTA brings enterprise IT, future-ready education, and digital services together in one platform. Built for what's next."
      />
      <StructuredData schemas={schemas} />
      <Header />
      <main>
        <HeroSlider />
        <FeaturedService />
        <WinningBundlesRail />
        <AboutSection />
        <ServicesGrid />
        <WhyChoose />
        <ShopSection />
        <TaglineSection />
        <TrustSection />
        <ContactSection />
      </main>
      <RecommendedForYou division="home" heading="Start where you need us most" />
      <CrossDivisionStrip hide={['home']} />
      <AppearancePreFooter />
      <Footer />
      <ContinueShoppingChip />
    </div>
  );
}
